var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hasMask ? _c('div', {
    staticClass: "absolute overflow-hidden",
    staticStyle: {
      "clip-path": "polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)"
    },
    style: _vm.blobMaskTransform
  }, [_c('div', {
    staticClass: "absolute",
    style: _vm.blobMaskRelativeTransform
  }, [_vm._t("default")], 2)]) : _c('div', {
    staticClass: "absolute",
    style: _vm.blobTransform
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }